module.exports = __webpack_public_path__ + "img/oneGreen.745ef076.jpg";